<template>
  <el-dialog :visible.sync="dialogVisible"
             title="详情"
             @close="handleClose">
    <el-form :model="detailInfo"
             ref="ruleForm"
             label-width="100px"
             class="add-ruleForm">
      <el-row>
        <el-col :span="8">
          <el-form-item label="任务名称："
                        prop="taskName">
            {{detailInfo.taskName}}
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="是否启用："
                        prop="status">
            {{status[detailInfo.status]}}
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="描述："
                        prop="desc">
            {{detailInfo.desc}}
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="限速：">
            {{detailInfo.overSpeed +' km/h'}}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="允许上浮速度："
                        label-width="126px"
                        prop="desc">
            {{detailInfo.floatSpeed +' km/h'}}
          </el-form-item>
        </el-col>
      </el-row>
      <!-- <el-row>
        <el-col :span="8">
          <el-form-item label="布控摄像头">
          </el-form-item>
        </el-col>
      </el-row> -->
    </el-form>
    <!-- <div class="item-label"><label>布控摄像头：</label></div> -->
    <div class="cam-name flex-wrap">
      <div>
        <label>摄像机：</label>
        <span>{{detailInfo.cameras}}</span>
      </div>
      <div>
        <label>距离：</label>
        <span>{{detailInfo.distance}}</span>
        <span>m</span>
      </div>
    </div>
    <div class="camera-choose">
      <div id="view-map">
      </div>
    </div>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="dialogVisible = false">确定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { api } from '../api'
export default {
  components: {
  },
  props: {
    // detailInfo: {
    //   type: Object,
    //   default: {

    //   }
    // },
  },
  data () {
    return {
      dialogVisible: false,
      detailInfo: {},
      status: {
        '1': '启动',
        '2': '禁止'
      }
    }
  },
  mounted () {
  },
  created () {

  },
  computed: {
  },
  methods: {
    open (row) {
      // this.detailInfo = row;
      this.queryMeasureSpeedDetail(row.taskCode)
    },
    handleClose () {
      this.$map.hideMap2D();
    },
    initMap () {
      this.$map.MapInstance2D.setMapOption();
      this.$map.MapInstance2D.resetMapStyle('view-map');
      // this.$map.MapInstance2D.getLocation(this.getLocationCB);
      let trajectory = [];
      let startDeviceInfo = {
        thirdDeviceId: this.detailInfo.startCameraId,
        deviceName: this.detailInfo.startCameraName,
        areaName: this.detailInfo.startAreaName,
        statusName: this.detailInfo.startStatus == '1' ? '在线' : '离线',
        factoryName: this.detailInfo.startFactoryName,
        createrTime: this.detailInfo.startCreaterTime
      }

      let endDeviceInfo = {
        thirdDeviceId: this.detailInfo.endCameraId,
        deviceName: this.detailInfo.endCameraName,
        areaName: this.detailInfo.endAreaName,
        statusName: this.detailInfo.endStatus == '1' ? '在线' : '离线',
        factoryName: this.detailInfo.endFactoryName,
        createrTime: this.detailInfo.endCreaterTime
      }
      trajectory.push({
        point: [this.detailInfo.startLongitude, this.detailInfo.startLatitude, `./images/theme/newDark/map/camera.png`, startDeviceInfo, 'speed_config'],
        id: this.detailInfo.startCameraId
      })
      trajectory.push({
        point: [this.detailInfo.endLongitude, this.detailInfo.endLatitude, `./images/theme/newDark/map/camera.png`, endDeviceInfo, 'speed_config'],
        id: this.detailInfo.endCameraId
      })
      console.log('摄像机轨迹点=====', trajectory)
      this.$map.MapInstance2D.drawTrajectory(trajectory, 1.2);
    },
    queryMeasureSpeedDetail (code) {
      this.$fetch(api.measurespeed.queryMeasureSpeedDetail, { taskCode: code }).then(response => {
        if (response && response.success) {
          this.detailInfo = response.returnObj;
          this.$map.showMap2D(this.initMap);
        } else {
          this.$message.error(response.msgContent)
        }
      })
    }
  }
}
</script>
<style lang="scss">
@import "../style/speed.scss";
</style>
